import { ExcludeType, PickListExportFieldsStatus, PickListExportItem } from "@/services/api/moreFeatures/pickList";
// 排除订单选项
const excludeTypes = [
    {
        label: "排除已打印快递单的订单",
        value: ExcludeType.EXCLUDE_WAYBILL_NO_PRINTED,
    },
    { label: "排除不可达订单", value: ExcludeType.EXCLUDE_UNDELIVERABLE_AREA },
    {
        label: "排除已打印发货单的订单",
        value: ExcludeType.EXCLUDE_PACK_LIST_PRINTED,
    },
    { label: "排除退款中的订单", value: ExcludeType.EXCLUDE_REFUNDING_PRINTED },
    { label: "排除挂起的订单", value: ExcludeType.EXCLUDE_ON_HOLD_PRINTED },
    { label: "排除预发货的订单", value: ExcludeType.EXCLUDE_PRE_SHIPPING },
];

export const PickListExportItemNameMap = {
    [PickListExportItem.ITEM_IMAGE]: "商品图片",
    [PickListExportItem.ITEM_TITLE]: "商品简称/标题",
    [PickListExportItem.PRODUCT_TITLE]: "商品标题",
    [PickListExportItem.PRODUCT_SIMPLE_TITLE]: "商品简称",
    [PickListExportItem.SELLER_CODE]: "宝贝商家编码",
    [PickListExportItem.PRODUCT_ORIGINAL_IDS]: "商品ID",
    [PickListExportItem.STOCK_SITE]: "货位",
    [PickListExportItem.SIMPLE_IMAGE]: "单品图片",
    [PickListExportItem.SIMPLE_TITLE]: "单品简称",
    [PickListExportItem.SIMPLE_PROPERTY]: "单品属性",
    [PickListExportItem.SIMPLE_SELLER_CODE]: "单品商家编码",
    [PickListExportItem.SIMPLE_PRICE]: "单品价格",
    [PickListExportItem.QUANTITY]: "单品数量",
    [PickListExportItem.REFUNDING_QUANTITY]: "退款中单品数量",
    [PickListExportItem.SELLER_REMARK]: "卖家备注",
    [PickListExportItem.BUYER_REMARK]: "买家留言",
    [PickListExportItem.TOTAL]: "数量总和",
};

/** 订单相关导出项固定展示，不参与拖拽排序 */
const orderRelatedExportItemValues = [PickListExportItem.SELLER_REMARK, PickListExportItem.BUYER_REMARK];

/** 补齐后端尚未保存的新字段，并将订单相关字段固定放在最后(已排序) */
export const getAllPickListExportFields = (savedFieldStatuses: PickListExportFieldsStatus[] = []) => {
    const allExportItems = Object.keys(PickListExportItem) as PickListExportItem[];
    const allExportItemSet = new Set(allExportItems);
    const savedValues = savedFieldStatuses
        .map(({ exportItem: field }) => field)
        .filter((field) => !!field && allExportItemSet.has(field));
    const missingValues = allExportItems.filter((value) => !savedValues.includes(value));
    const completedValues = [...savedValues, ...missingValues];

    return [
        ...completedValues.filter((value) => !orderRelatedExportItemValues.includes(value)),
        ...orderRelatedExportItemValues,
    ];
};

export { excludeTypes, orderRelatedExportItemValues };
